module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sign-up-judge",
    attrs: {
      "id": "section-sign-up-judge"
    }
  }, [_c('form-dynamix', {
    attrs: {
      "type": "judge",
      "feedback": _vm.feedback,
      "loading": _vm.loading,
      "names": _vm.names,
      "models": _vm.models,
      "attributes": _vm.attributes,
      "vuelidate": _vm.$v,
      "is-print": _vm.isPrint,
      "is-print-pdf": _vm.isPrintPdf
    },
    on: {
      "recaptcha": _vm.onRecaptcha,
      "send": _vm.onSend
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de8b88e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SignUpJudgeSection.vue
// module id = 909
// module chunks = 1